<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
                <h3 class="primary--text formName">Choose the account to transfer admin rights.</h3>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3"  @submit.prevent="submit">
          <div class="row mb-3">
                    <span class="fieldTitle">User account</span>
                    <div class="col-12">
                      <v-autocomplete v-model="input.newowner" closable-chips  :items="userManaged" item-color="#FFF" :item-title="getItemText" item-value="_id" chips ></v-autocomplete>

                        <div class="alert alert-warning text-left mt-3 " v-if="v$.input.newowner.$errors.length > 0">
                            <div  v-for="(error, index) of v$.input.newowner.$errors" :key="index">{{ error.$message }}</div>
                        </div>
                    </div>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Cancel
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Transfer
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
    userManaged : Array,
  },
  setup () {
     return { v$: useVuelidate() }
  },
  data () {
    return{
      input: {
        newowner:null,
      },

    }
  },
  validations () {
   return {
     input:{
       newowner: {
         required,
       },

     }
   }
 },
  methods:{
    async submit(){
        const isFormCorrect = await this.v$.$validate()
        console.log(this.input);
        if(isFormCorrect){
          this.$emit('newValueIsProposed',this.input)
        }

    },
    close(){
        this.$emit('close',false)
    },
    getItemText(item) {
      return `${item.firstname} ${item.lastname}`;
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },


}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }

  .loginpage{
    padding: 50px;
  }
  .loginpage form{
    background: #FFF;
    padding: 50px;
    border-radius: 20px;
    max-width: 800px;
  margin: auto;
  }

  .loginpage form input{
    border: 1px solid #DDDDDD;
  border-radius: 2px;
  width: 100%;
  height: 40px;
  padding: 5px;
  }
  .next_step_btn,
  .next_step_btn:hover{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }

  .sidebar_logo{
    width: 180px;

  }
  .fieldTitle{
    text-align:left;
    color:#3783C5;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 5px;
    margin-top: 10px;
  }
</style>
